import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import RowAddButton from '../buttons/RowAddButton';

const TableHeaderAddRow = ({
  className,
  entity,
  children,
  disabled,
  onClick,
  colSpan = 1,
  extraContent = undefined,
}) => (
  <Table.Row
    className={clsx('aridhia-table-header-add-row relative z-1', className)}
    verticalAlign="top"
  >
    <Table.HeaderCell colSpan={colSpan}>{children}</Table.HeaderCell>
    {extraContent}
    <Table.HeaderCell collapsing>
      <RowAddButton disabled={disabled} entity={entity} onClick={onClick} />
    </Table.HeaderCell>
  </Table.Row>
);

export default TableHeaderAddRow;
